import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Home from "../pages/Home";
import { Education } from "../pages/Education";
import { Experience } from "../pages/Experience";
import { Certifications } from "../pages/Certifications";
import { Portfolio } from "../pages/Portfolio";
import { Skills } from "../pages/Skills";
import "../index.css";
import { Fotter } from "../componets/Fotter";
import Contact from "../pages/Contact";
import { GreenNotes } from "../layouts/GreenNotes";
import { LearningList } from "../layouts/LearningList";
import { Pokedex } from "../layouts/Pokedex";
import { GreenWay } from "../layouts/GreenWay";
import { MemoryMatch } from "../layouts/MemoryMatch";
import { DesingCanvas } from "../layouts/DesingCanvas";
import { PizzaApp } from "../layouts/PizzaApp";
import { CardValidation } from "../layouts/CardValidation";
import { RickAndMorty } from "../layouts/RickAndMorty";
import { GifApp } from "../layouts/GifApp";


export const RouterApp = () => {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/education" element={<Education />} />
      <Route path="/experience" element={<Experience />} />
      <Route path="/certifications" element={<Certifications />} />
      <Route path="/portfolio" element={<Portfolio />} />
      <Route path="/skills" element={<Skills />} />
      <Route path="/green-notes" element={<GreenNotes />} />
      <Route path="/learning-list" element={<LearningList />} />
      <Route path="/pokedex" element={<Pokedex />} />
        <Route path="/greenway" element={<GreenWay />} />
        <Route path="/desing-canvas" element={<DesingCanvas />} />
      <Route path="/memory-match" element={<MemoryMatch />} />
      <Route path="/card-validation" element={<CardValidation />} />
      <Route path="/pizza-app" element={<PizzaApp />} />
      <Route path="/rick-and-morty" element={<RickAndMorty />} />
      <Route path="/gif-app" element={<GifApp />} />
      <Route path="/contact" element={<Contact />} />
    </Routes>
  );
};
